import CostService from "@/store/services/cost.service.js";
import InvoiceService from "@/store/services/invoice.service.js";
import TripService from "@/store/services/trip.service";
import CustomerService from "@/store/services/customer.service";
import QuotationService from "@/store/services/quotation.service";
import CorrectionService from "../services/correction.service";

export default {
  namespaced: true,
  state: {
    dummy: false
  },
  getters: {

  },
  mutations: {
    TIMELINE_LIST_REFRESH (state) {
      state.dummy = !state.dummy
    },
  },
  actions: {
    loadPayment (context, payment_id) {
      return InvoiceService.getPayment(payment_id).then((response) => {
        return response
      })
    },
    loadCost (context, cost_id) {
      return CostService.retrieve(cost_id, { extended: 'True' }).then((response) => {
        return response
      })
    },
    loadTrip (context, trip_id) {
      return TripService.retrieve(trip_id).then((response) => {
        return response
      })
    },
    loadContact (context, contact_id) {
      return CustomerService.retrieve(contact_id).then((response) => {
        return response
      })
    },
    loadQuotation (context, quotation_id) {
      return QuotationService.retrieve(quotation_id, { extended: 'True' }).then((response) => {
        return response
      })
    },
    loadInvoice (context, invoice_id) {
      return InvoiceService.retrieve(invoice_id, { extended: 'True' }).then((response) => {
        return response
      })
    },
    loadEmailReport (context, email_id) {
      return InvoiceService.getEmailReport(email_id).then((response) => {
        return response
      })
    },
    emailIgnoreFailure (context, email_id) {
      return InvoiceService.emailIgnoreFailure(email_id).then((response) => {
        return response
      })
    },
    loadCorrection(context, invoice_id){
      return InvoiceService.retrieve(invoice_id, { extended: 'True' }).then((response) => {
        return response
      })
    }
  }
}
